import { isTodo, screenshots } from './content';

/** Renders nothing until at least one real screenshot exists — a section of empty frames sells nothing. */
export const Screenshots = () => {
  if (screenshots.every((shot) => isTodo(shot.src))) return null;

  return (
    <section id="screenshots" className="lp-section lp-section--alt">
      <div className="lp-container">
        <h2>The review queue</h2>
        <p className="lp-section__intro">
          What staff see: each order with what the retailer said and how every line was matched.
        </p>
        <div className="lp-shots">
          {screenshots.map((shot) => (
            <figure key={shot.alt} className={`lp-shot lp-shot--${shot.shape}`}>
              <div className="lp-shot__frame">
                {isTodo(shot.src) ? (
                  <div className="lp-shot__placeholder" role="img" aria-label={shot.alt}>
                    <span className="lp-todo">TODO: screenshot</span>
                    <code>{shot.src.replace(/^TODO:\s*/, 'public')}</code>
                  </div>
                ) : (
                  <img src={shot.src} alt={shot.alt} loading="lazy" decoding="async" />
                )}
              </div>
              <figcaption>{shot.caption}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
